import { PostMethod } from '../../../serviceHelper';

const getMethods = (service: 'Studio', controller: 'DataSource/SAP') => ({
	GetFunctionInterface: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetFunctionInterface'
	}),
	GetFunctionDocu: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetFunctionDocu'
	}),
	GetTableStructureDefinition: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetTableStructureDefinition'
	}),
	InvokeRfc: new PostMethod<any, any>({
		service,
		controller,
		method: 'InvokeRfc'
	}),
	SearchFunction: new PostMethod<any, any>({
		service,
		controller,
		method: 'SearchFunction'
	}),
	SearchFunctionGroup: new PostMethod<any, any>({
		service,
		controller,
		method: 'SearchFunctionGroup'
	}),
	GetFunctionGroupDocu: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetFunctionGroupDocu'
	}),
	GetTreeInit: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetTreeInit'
	}),
	GetObjInterfaces: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetObjInterfaces'
	}),
	GetObjMethods: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetObjMethods'
	}),
	GetObjKeyFields: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetObjKeyFields'
	}),
	GetObjAttributes: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetObjAttributes'
	}),
	GetObjEvents: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetObjEvents'
	}),
	GetObjDocuLines: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetObjDocuLines'
	}),
	GetMethodDocuLines: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetMethodDocuLines'
	}),
	GetParameterDocu: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetParameterDocu'
	}),
	GetMethodParameters: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetMethodParameters'
	}),
	GetRfcList: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetRfcList'
	}),
	GetFunctionGroups: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetFunctionGroups'
	}),
	GetFunctions: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetFunctions'
	})
});

export { getMethods };
